import React, { ReactNode } from "react";
import * as S from "./CarouselContent.styles";
import { IPrincipleSection } from "../OverviewBrandPrinciples.types";
import { useTranslation } from "hooks/useTranslation";

export const CarouselContent = ({
  item,
  children,
}: Readonly<{ item: IPrincipleSection; children: ReactNode }>) => {
  const { t } = useTranslation();

  return (
    <S.CarouselWrapper>
      <S.SlideContainer>
        <S.ContentContainer>
          <S.SlideHeader>
            <S.SlideTitle
              dangerouslySetInnerHTML={{
                __html: t(item.title),
              }}
            />

            {item.description && (
              <S.SlideDescription>{t(item.description)}</S.SlideDescription>
            )}
          </S.SlideHeader>

          <S.SlidesListContainer>
            {item.slides.map((item) => (
              <S.SlideItem key={`item-${item.id}`} $isActive={false}>
                {item.icon}
                <S.SlideText
                  dangerouslySetInnerHTML={{ __html: t(item.text) }}
                />
              </S.SlideItem>
            ))}

            {item?.slides?.length < 4 && <S.SlideItem $isActive={false} />}
          </S.SlidesListContainer>
        </S.ContentContainer>
      </S.SlideContainer>

      {children}
    </S.CarouselWrapper>
  );
};
